import React from "react";
import BarCharts from "../Charts/BarChart";
import PieCharts from "../Charts/PieChart";

const DetailsDashboard = () => {
  return (
    <div className="container">
      <div className="grid grid-cols-4 gap-5 p-5">
        <div className="shadow-lg text-black-500  text-center p-5 rounded-lg bg-gradient-to-r from-green-200 via-blue-200 to-white ">
          <div className="grid grid-cols-2 ">
            <div className=" text-black-500   text-center p-5 ">
              <div className="block text-grey-darker text-sm mb-2">
                <span className="font-bold">Total user</span>
              </div>
              <div className="block text-grey-darker text-sm font-bold mb-2">
                <span className="text-4xl">4721</span>
              </div>
              <div className="block text-grey-darker text-sm  mb-2">
                <span className="text-[#98c6eb]">5% </span>
                <span>last week</span>
              </div>
            </div>
            <div className=" text-black-500  text-center p-5  ">
              <img
                src="/assets/bar-chart-icon .png"
                alt="pic"
                className="h-20 w-full  "
              />
            </div>
          </div>
        </div>
        <div className="shadow-lg text-black-500  text-center p-5 rounded-lg bg-gradient-to-r from-green-200 via-blue-200 to-white ">
          <div className="grid grid-cols-2 ">
            <div className=" text-black-500   text-center p-5 ">
              <div className="block text-grey-darker text-sm  mb-2">
                <span className="font-bold">Total Profit</span>
              </div>
              <div className="block text-grey-darker text-sm font-bold mb-2">
                <span className="text-4xl">4721</span>
              </div>
              <div className="block text-grey-darker text-sm  mb-2">
                <span className="text-[#d361cd]">5% </span>
                <span>last week</span>
              </div>
            </div>
            <div className=" text-black-500  text-center p-5 ">
              <img
                src="/assets/bar-chart-icon .png"
                alt="pic"
                className="h-20 w-full "
              />
            </div>
          </div>
        </div>
        <div className="shadow-lg text-black-500  text-center p-5 rounded-lg bg-gradient-to-r from-green-200 via-blue-200 to-white ">
          <div className="grid grid-cols-2 ">
            <div className=" text-black-500  text-center p-5 ">
              <div className="block text-grey-darker text-sm mb-2">
                <span className="font-bold">Total Expenses</span>
              </div>
              <div className="block text-grey-darker text-sm font-bold mb-2">
                <span className="text-4xl">4721</span>
              </div>
              <div className="block text-grey-darker text-sm  mb-2">
                <span className="text-[#61c1d3]">5% </span>
                <span>last week</span>
              </div>
            </div>
            <div className=" text-black-500  text-center p-5 ">
              <img
                src="/assets/bar-chart-icon .png"
                alt="pic"
                className="h-20 w-full "
              />
            </div>
          </div>
        </div>
        <div className="shadow-lg text-black-500  text-center p-5 rounded-lg bg-gradient-to-r from-green-200 via-blue-200 to-white ">
          <div className="grid grid-cols-2 ">
            <div className=" text-black-500   text-center p-5 ">
              <div className="block text-grey-darker text-sm mb-2">
                <span className="font-bold">Total Cost</span>
              </div>
              <div className="block text-grey-darker text-sm  font-bold mb-2">
                <span className="text-4xl">4721</span>
              </div>
              <div className="block text-grey-darker text-sm  mb-2">
                <span className="text-[#ea4805]">5% </span>
                <span>last week</span>
              </div>
            </div>
            <div className=" text-black-500  text-center p-5 ">
              <img
                src="/assets/bar-chart-icon .png"
                alt="pic"
                className="h-20 w-full "
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="grid grid-cols-4 gap-4 p-10">
          <div className="shadow-lg text-black-500  text-lg pt-5 rounded-lg col-span-3">
            <div className=" border-b-2 p-3 ">
              <span className="mx-10 text-lg font-bold">Sales Analytics</span>
            </div>
            <div className="w-full h-96 mt-5">
              <BarCharts />
            </div>
          </div>
          <div className="shadow-lg text-black-500 text-lg  text-center  rounded-lg ">
            <img
              src="/assets/depositphotos.jpg"
              alt="pic"
              className="h-80 w-full "
            />

            <div className="grid grid-cols-2 p-3 ">
              <div className=" text-black-500   ">
                <span className="text-md font-semibold ">Delivered Order</span>
                <div className="block  text-sm ">
                  <span className="text-[#98c6eb]">3.5% </span>
                  <span className="text-md">increased</span>
                </div>
              </div>
              <span className="text-3xl ">4,721</span>
            </div>
            <div className="grid grid-cols-2 p-3 ">
              <div className=" text-black-500   ">
                <span className="text-md font-semibold ">Canceled Order</span>
                <div className="block text-sm ">
                  <span className="text-[#98c6eb]">1.5% </span>
                  <span className="text-md">increased</span>
                </div>
              </div>
              <span className="text-3xl ">4,721</span>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="grid grid-cols-3 gap-5 p-10">
          <div className="shadow-lg text-black-500 text-lg  text-center pt-5 rounded-lg  ">
            <div className="border-b-2">
              <span>Daily Activity</span>
            </div>
          </div>
          <div className="shadow-lg text-black-500 text-lg  text-center pt-5 rounded-lg  ">
            <div className="border-b-2">
              <span>Sales Report by Locations Devices</span>
            </div>
            <img
              src="/assets/world_map_PNG28.png"
              alt="pic"
              className="h-64 w-full "
            />
            <div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3">Device </th>
                    <th className="py-3">USA</th>
                    <th className="py-3">INDIA</th>
                    <th className="py-3">Spain</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                      Mobile
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      17%
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      22%
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      22%
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                      Desktop
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      17%
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      22%
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      22%
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                      Tablets
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      17%
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      22%
                    </td>
                    <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                      22%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="shadow-lg text-black-500 text-lg  text-center pt-5 rounded-lg  ">
            <div className="border-b-2">
              <span>Browser Usage</span>
            </div>
            <div className="w-full h-80 mt-5">
              <PieCharts />
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols gap-5 p-10">
        <div className="shadow-lg text-black-500 text-lg  text-center p-5 rounded-lg "></div>
      </div>
    </div>
  );
};

export default DetailsDashboard;
